import { lazy } from 'react';

const GeneralAccountsSettingsPage = lazy(() => import('../pages/GeneralAccountsSettings.page'));
const NextFinancialPeriodPage = lazy(() => import('../pages/NextFinancialPeriod.page'));

const GeneralAccountsSettingsRoutes = [
    {
        path: '/general-accounts-settings',
        element: <GeneralAccountsSettingsPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/general-accounts-settings/next-period',
        element: <NextFinancialPeriodPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { GeneralAccountsSettingsRoutes };
